module.exports = require("lodash.flatten");